
export const Fetch = {
    LogOutUser: "/api/MasterMobileAPI/ForceLogout",
    Notification: "/api/notificationAPI/GetNotifications",


    // Resevation Api 
    ReservationLogin: "/api/MasterMobileAPI/ReservationLogin",
    PropertyList: "/API/ReservationWebAPI/PropertyList",
    ReserPreBookingContinue: "/API/ReservationWebAPI/PreBooking",
    ReserBookingAddRoom: "/API/ReservationWebAPI/PreBookingRoomAdd",
    ReserPreBookingdetail: "/API/ReservationWebAPI/PreBookingDetails",
    ReserPreBookingConfirm: "/API/ReservationWebAPI/BookingCheckoutSave",
    ReserBookingList: "/API/ReservationWebAPI/BookingList",
    BookingPDF: "/API/ReservationWebAPI/BookingVoucherDetails",

    ReserBookingCancel: "/API/ReservationWebAPI/BookingCancel",
    ReserRAteCodeList: "/API/ReservationWebAPI/RateCodeTypeList",
    ReservationRoomInventory: "/API/ReservationWebAPI/ReservationRoomInventory",

    ReservationAgentList: "/API/ReservationWebAPI/AgentList",
    ReservationSaveAgent: "/API/ReservationWebAPI/AgentInfoSave",
    ReserAgentproduReport: "/API/ReservationWebAPI/TravelAgentProductivityReport",

    ReservationCorporateList: "/API/ReservationWebAPI/CorporateList",
    ReservationSaveCorporate: "/API/ReservationWebAPI/CorporateInfoSave",
    ReserCompanyproduReport: "/API/ReservationWebAPI/CorporateProductivityReport",

    ReservationPMSDetail: "/API/ReservationWebAPI/PMSProfileDetailsSelect",

    ReservationRateCodeList: "/API/webratecode/list",
    ReservationSaveRateCode: "/API/webratecode/save",
    ResvationDeleteRateCode: "/API/ratecode/delete",

    ReservationMealPlan: "/API/webratecode/MealPlanList",
    ReservationSaveMealPlan: "/API/webratecode/MealPlanSave",

    ReservationRoomDetail: "/API/ReservationWebAPI/PropertyRoomList",

    ReservationMappingList: "/API/webratecode/RateCodeMealPlanList",
    ReservationSaveMapping: "/API/webratecode/RateCodeMealPlanSave",

    ReservationMarketSegment: "/API/ReservationWebAPI/MarketSegmentList",
    ReservationSaveMarkSegment: "/API/ReservationWebAPI/MarketSegmentInsert",

    ReservationBusinessSource: "/API/ReservationWebAPI/BusinessSourceList",
    ReservationSaveBusinessSource: "/API/ReservationWebAPI/BusinessSourceInsert",

    ReservationGuaranteeCode: "/API/ReservationWebAPI/GuaranteeCodesList",
    ReservationSaveGuaranteeCodes: "/API/ReservationWebAPI/GuaranteeCodesInsert",

    ReserRoomRateSelect: "/API/ReservationWebAPI/RoomRateSelect",
    ReserDeletePreRoom: "/API/ReservationWebAPI/PreBookingRoomDelete",

    RserDynamicVoucher: "/API/ReservationWebAPI/BookingVoucherGen",

    ReserBookingCancleResion: "/API/ReservationWebAPI/CancellationReasons",
    ReserBookingCancled: "/API/ReservationWebAPI/BookingCancel",
    ReserSendVoucher: "/API/ReservationWebAPI/BookingVoucherSend",
    ReserBookingVouserDetails: "/API/ReservationWebAPI/BookingVoucherDetails",
    ReserBusinessSourceReport: "/API/ReservationWebAPI/BusinessSourceProductivityReport",
    ReserMarketSegmentReport: "/API/ReservationWebAPI/MarketSegmentProductivityReport",
    ReserBusinessMonthlyReport: "/API/ReservationWebAPI/BusinessSourceProductivityMonthlyReport",
    ReserBusinessPropertyMonthlyReport: "/API/ReservationWebAPI/BusinessSourcePropertyProductivityMonthlyReport",
    ReserBusinessYearlyReport: "/API/ReservationWebAPI/BusinessSourceProductivityYearlyReport",
    ReserBusinessPropertyYearlyReport: "/API/ReservationWebAPI/BusinessSourcePropertyProductivityYearlyReport",

    ReserVoucherTermsAndCondition: "/api/voucher/terms/get",
    ReserAddTermsAndCon: "/api/voucher/terms/save",
    ReserDeleteTermsAndCon: "/api/voucher/terms/Delete",
    ReserUpdateTermsAndCon: "/api/voucher/terms/save",

    ReserVoucherConnectivity: "/api/voucher/connectivity/get",
    ReserAddConnectivity: "/api/voucher/connectivity/save",
    ReserDeleteConnectivity: "/api/voucher/connectivity/Delete",
    ReserUpdateConnectivity: "/api/voucher/connectivity/save",

    ReserVoucherOffers: "/api/voucher/offers/get",
    ReserAddVoucherOffers: "/api/voucher/offers/save",
    ReserDeleteVoucherOffers: "/api/voucher/offers/Delete",
    ReserUpdateVoucherOffers: "/api/voucher/offers/save",

    // Agent Api
    AgentRoomlist: "/API/AgentMobileAPI/PropertyRoomList",
    AgentPreBookingContinue: "/API/AgentMobileAPI/PreBooking",
    AgentPrebookingGuentdetails: "/API/AgentMobileAPI/PreBookingGuestDetailsSave",
    AgentPrebookingCompanydetails: "/API/AgentMobileAPI/PreBookingCompanyDetailsSave",
    AgentPrebookingComment: "/API/AgentMobileAPI/PreBookingBookingCommentDetailsSave",
    AgentGuestDetail: "/API/AgentMobileAPI/PreBookingGuestDetails",
    AgentPrebookingConfirm: "/API/AgentMobileAPI/PreBookingConfirmBookingSave",



    // agent new api
    Agentloginapi: "/api/MasterMobileAPI/AgentLogin",
    AgentProplist: "/API/AgentMobileAPI/PropertyList",
    AgentWebPreBookingContinue: "/API/AgentMobileAPI/PreBookingWeb",
    AgentAddRoomWeb: "/API/AgentMobileAPI/PreBookingRoomAdd",
    AgentBookingDetails: "/API/AgentMobileAPI/PreBookingDetails",
    AgentRoomDelete: "/API/AgentMobileAPI/PreBookingRoomDelete",
    AgentConfirmBooking: "/API/AgentMobileAPI/BookingCheckoutSave",
    AgentBookinglist: "/API/AgentMobileAPI/BookingList",
    AgentBookingCancelReason: "/API/AgentMobileAPI/CancellationReasons",
    AgentBookingCancle: "/API/AgentMobileAPI/BookingCancel",
    AgentBookingWebVoucher: "/API/AgentMobileAPI/BookingVoucherDetails",

    // Property Api
    Proporetylogin: "/api/PropertyMobileAPI/UserLogin",
    DashboardRoomInventory: "/API/PropertyMobileAPI/PropertyRoomInventory",

    BasicPropoertydetails: "/API/PropertyMobileAPI/PropertyBasicInfo",
    BasicPropertydetailSave: "/API/PropertyMobileAPI/PropertyBasicInfoSave",
    BasicContactdetail: "/API/PropertyMobileAPI/PropertyContact",
    BasicContactdetailSave: "/API/PropertyMobileAPI/PropertyContactSave",
    BasicPropertyLocation: "/API/PropertyMobileAPI/PropertyLocation",
    BasicPropertylocationSave: "/API/PropertyMobileAPI/PropertyLocationSave",
    BasicBankdetail: "/API/PropertyMobileAPI/PropertyBank",
    BasicBankdetailSave: "/API/PropertyMobileAPI/PropertyBankSave",
    BasicGstdetail: "/API/PropertyMobileAPI/PropertyTaxDetails",
    BasicGstdetailSave: "/API/PropertyMobileAPI/PropertyTAXDetailsSave",

    AmenitesDetails: "/API/PropertyMobileAPI/PropertyAmenities",
    SaveAmenitiesdetail: "/API/PropertyMobileAPI/PropertyAmenitiesSave",

    Roomdetail: "/API/PropertyMobileAPI/PropertyRoomList",
    Saveroomdetail: "/API/PropertyMobileAPI/PropertyRoomListSave",
    SaveMealplan: "/API/PropertyMobileAPI/PropertyRoomMealPlanSave",

    NewBooking: "/API/PropertyMobileAPI/PreBooking",
    PrebookingroomAdd: "/API/PropertyMobileAPI/PreBookingRoomAdd",
    PreBookingdetails: "/API/PropertyMobileAPI/PreBookingDetails",
    SavePreBookingconfirm: "/API/PropertyMobileAPI/BookingCheckoutSave",
    PropertyBookinglist: "/API/PropertyMobileAPI/BookingList",
    DeleteRoomdetail: "/API/PropertyMobileAPI/PreBookingRoomDelete",
    EditBookingdetail: "/API/PropertyMobileAPI/BookingDetails",
    PropertyBookingVoucher: "/API/PropertyMobileAPI/BookingVoucherDetails",
    BookingCancelReason: "/API/PropertyMobileAPI/CancellationReasons",
    BookingCancle: "/API/PropertyMobileAPI/BookingCancel",

    Agentlist: "/API/PropertyMobileAPI/AgentList",
    AgnetContactList: "/API/PropertyMobileAPI/AgentContactList",
    Agentsavedetails: "/API/PropertyMobileAPI/AgentInfoSave",

    Corporatedetail: "/API/PropertyMobileAPI/CorporateList",
    CorporateContactlist: "/API/PropertyMobileAPI/CorporateContactList",
    CorporateDetailSave: "/API/PropertyMobileAPI/CorporateInfoSave",


    BulRoomRateUpdate: "/API/PropertyMobileAPI/BulkRateUploadSave",

    MarSegmant: "/API/PropertyMobileAPI/MarketSegmentList",
    SaveMArSegment: "/API/PropertyMobileAPI/MarketSegmentInsert",

    BusinessSourList: "/API/PropertyMobileAPI/BusinessSourceList",
    SaveBusinessSource: "/API/PropertyMobileAPI/BusinessSourceInsert",

    PMSDetailsFind: "/API/PropertyMobileAPI/PMSProfileDetailsSelect",

    PropertyMealPlanList: "/API/ratecode/MealPlanList",
    PropertyAddMealPlan: "/API/ratecode/MealPlanSave",
    DeleteMealPlan: "/API/ratecode/MealPlanDelete",

    PropertyRateCodeList: "/API/ratecode/list",
    RatecodeType: "/API/PropertyMobileAPI/RateCodeTypeList",
    PropertyAddRateCode: "/API/ratecode/save",
    DeleterateCode: "/API/ratecode/delete",

    MappingList: "/API/ratecode/RateCodeMealPlanList",
    SaveMapping: "/API/ratecode/RateCodeMealPlanSave",
    DeleteMapping: "/API/ratecode/RateCodeMealPlanDelete",

    GuaranteeCodes: "/API/PropertyMobileAPI/GuaranteeCodesList",
    SaveGuaranteeCodes: "/API/PropertyMobileAPI/GuaranteeCodesInsert",


    RoomRateSelect: "/API/PropertyMobileAPI/RoomRateSelect",

    Report: "/API/PropertyReportAPI/BookingList",

    BookingReport: "/API/PropertyReportAPI/BookingReport",
    BookingReportPDF: "/API/PropertyReportAPI/BookingReportPDF",

    DynamicVoucher: "/API/PropertyMobileAPI/BookingVoucherGen",
    VoucherSend: "/API/PropertyMobileAPI/BookingVoucherSend",
};
